// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 647 ? "second" : chunkId) + "." + {"647":"6bcfea0d","979":"e087d8f0"}[chunkId] + ".css";
};